const contextualizedTranslationMap: {
  [key: string]: { [key: string]: string };
} = {
  card: {
    action_add_attachment_to_card: 'action_add_attachment_to_card@card',
    action_add_checklist_to_card: 'action_add_checklist_to_card@card',
    action_add_label_to_card: 'action_add_label_to_card@card',
    action_added_a_due_date: 'action_added_a_due_date@card',
    action_added_member_to_card: 'action_added_member_to_card@card',
    action_added_member_to_checkitem: 'action_added_member_to_checkitem@card',
    action_archived_card: 'action_archived_card@card',
    action_changed_a_due_date: 'action_changed_a_due_date@card',
    action_changed_description_of_card:
      'action_changed_description_of_card@card',
    action_comment_on_card: 'action_comment_on_card@card',
    action_completed_checkitem: 'action_completed_checkitem@card',
    action_convert_to_card_from_checkitem:
      'action_convert_to_card_from_checkitem@card',
    action_copy_card: 'action_copy_card@card',
    action_copy_inbox_card: 'action_copy_inbox_card@card',
    action_create_card: 'action_create_card@card',
    action_create_inbox_card: 'action_create_inbox_card@card',
    action_delete_attachment_from_card:
      'action_delete_attachment_from_card@card',
    action_email_card: 'action_email_card@card',
    action_email_card_from: 'action_email_card_from@card',
    action_marked_checkitem_incomplete:
      'action_marked_checkitem_incomplete@card',
    action_marked_the_done_state_complete:
      'action_marked_the_done_state_complete@card',
    action_marked_the_done_state_incomplete:
      'action_marked_the_done_state_incomplete@card',
    action_marked_the_due_date_complete:
      'action_marked_the_due_date_complete@card',
    action_marked_the_due_date_incomplete:
      'action_marked_the_due_date_incomplete@card',
    action_member_joined_card: 'action_member_joined_card@card',
    action_member_joined_checkitem: 'action_member_joined_checkitem@card',
    action_member_left_card: 'action_member_left_card@card',
    action_member_left_checkitem: 'action_member_left_checkitem@card',
    action_move_card_from_board: 'action_move_card_from_board@card',
    action_move_card_from_list_to_list:
      'action_move_card_from_list_to_list@card',
    action_move_card_to_board: 'action_move_card_to_board@card',
    action_move_inbox_card_to_board: 'action_move_inbox_card_to_board@card',
    action_moved_card_higher: 'action_moved_card_higher@card',
    action_moved_card_lower: 'action_moved_card_lower@card',
    action_remove_checklist_from_card: 'action_remove_checklist_from_card@card',
    action_remove_label_from_card: 'action_remove_label_from_card@card',
    action_removed_a_due_date: 'action_removed_a_due_date@card',
    action_removed_member_from_card: 'action_removed_member_from_card@card',
    action_removed_member_from_checkitem:
      'action_removed_member_from_checkitem@card',
    action_removed_vote_for_card: 'action_removed_vote_for_card@card',
    action_renamed_card: 'action_renamed_card@card',
    action_sent_card_to_board: 'action_sent_card_to_board@card',
    action_update_custom_field_item: 'action_update_custom_field_item@card',
    action_vote_on_card: 'action_vote_on_card@card',
  },
  board: {
    action_add_to_organization_board: 'action_add_to_organization_board@board',
    action_added_list_to_board: 'action_added_list_to_board@board',
    action_added_member_to_board: 'action_added_member_to_board@board',
    action_added_member_to_board_as_admin:
      'action_added_member_to_board_as_admin@board',
    action_added_member_to_board_as_observer:
      'action_added_member_to_board_as_observer@board',
    action_became_a_normal_user_on: 'action_became_a_normal_user_on@board',
    action_board_perm_level: 'action_board_perm_level@board',
    action_changed_board_background: 'action_changed_board_background@board',
    action_closed_board: 'action_closed_board@board',
    action_create_board: 'action_create_board@board',
    action_create_custom_field: 'action_create_custom_field@board',
    action_created_an_invitation_to_board:
      'action_created_an_invitation_to_board@board',
    action_created_checklist_on_board:
      'action_created_checklist_on_board@board',
    action_delete_custom_field: 'action_delete_custom_field@board',
    action_deleted_an_invitation_to_board:
      'action_deleted_an_invitation_to_board@board',
    action_disabled_board_button_shortcut:
      'action_disabled_board_button_shortcut@board',
    action_disabled_board_button_shortcuts:
      'action_disabled_board_button_shortcuts@board',
    action_disabled_calendar_feed: 'action_disabled_calendar_feed@board',
    action_disabled_card_covers: 'action_disabled_card_covers@board',
    action_disabled_commenting: 'action_disabled_commenting@board',
    action_disabled_inviting: 'action_disabled_inviting@board',
    action_disabled_is_template: 'action_disabled_is_template@board',
    action_disabled_self_join: 'action_disabled_self_join@board',
    action_disabled_voting: 'action_disabled_voting@board',
    action_enabled_board_button_shortcut:
      'action_enabled_board_button_shortcut@board',
    action_enabled_board_button_shortcuts:
      'action_enabled_board_button_shortcuts@board',
    action_enabled_calendar_feed: 'action_enabled_calendar_feed@board',
    action_enabled_card_covers: 'action_enabled_card_covers@board',
    action_enabled_is_template: 'action_enabled_is_template@board',
    action_enabled_self_join: 'action_enabled_self_join@board',
    action_hid_board: 'action_hid_board@board',
    action_hid_vote_counts: 'action_hid_vote_counts@board',
    action_invited_an_unconfirmed_member_to_board:
      'action_invited_an_unconfirmed_member_to_board@board',
    action_joined_board: 'action_joined_board@board',
    action_joined_board_by_invitation_link:
      'action_joined_board_by_invitation_link@board',
    action_left_board: 'action_left_board@board',
    action_made_a_normal_user_on: 'action_made_a_normal_user_on@board',
    action_made_admin_of_board: 'action_made_admin_of_board@board',
    action_made_commenting_on: 'action_made_commenting_on@board',
    action_made_inviting_on: 'action_made_inviting_on@board',
    action_made_observer_of_board: 'action_made_observer_of_board@board',
    action_made_self_admin_of_board: 'action_made_self_admin_of_board@board',
    action_made_self_observer_of_board:
      'action_made_self_observer_of_board@board',
    action_made_voting_on: 'action_made_voting_on@board',
    action_moved_list_left: 'action_moved_list_left@board',
    action_moved_list_right: 'action_moved_list_right@board',
    action_remove_from_organization_board:
      'action_remove_from_organization_board@board',
    action_removed_from_board: 'action_removed_from_board@board',
    action_rename_custom_field: 'action_rename_custom_field@board',
    action_reopened_board: 'action_reopened_board@board',
    action_unhid_vote_counts: 'action_unhid_vote_counts@board',
    action_update_board_desc: 'action_update_board_desc@board',
    action_update_board_name: 'action_update_board_name@board',
    action_update_custom_field: 'action_update_custom_field@board',
  },
};

export const getContextualizedTranslationKey = (
  translationKey: string,
  location: '' | 'board' | 'card' | 'member' | undefined = undefined,
) => {
  if (!location || location === 'member') {
    return translationKey;
  }
  if (contextualizedTranslationMap[location][translationKey]) {
    return contextualizedTranslationMap[location][translationKey];
  }
  return translationKey;
};
